<template>
  <Post
    :id="id"
    :resource="resource"
    entity="Склады вне Украины"
  />
</template>

<script>
import Post from "../components/Post.vue";

export default {
  components: {
    Post,
  },
  props: ["id"],
  data() {
    return {
      resource: "posts/warehouses",
    };
  },
};
</script>
